export const todoListStyle = {
	wrapper: {
		maxWidth: '473px',
		width: '100%',
		padding: '16px',
		borderRadius: '8px',
		background: 'var(--default-white)',
		boxShadow: 'var(--box-shadow--1)',
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
	},

	header: {
		display: 'flex',
		alignItems: 'center',
		marginBottom: '4px',
		paddingRight: '10px',
	},

	amount: {
		flex: '1 1',
		marginLeft: '12px',
		color: 'var(--neutral-300)',
	},
};
